module.exports = {

    props: {
        value: {
            required: false,
            default: null,
        },
        name: {
            type: String,
            required: false,
            default: '',
        },
        placeholder: {
            type: [String, Object],
            required: false,
            default: '',
        },
        required: {
            type: Boolean,
            required: false,
            default: false,
        },
        autofocus: {
            type: Boolean,
            required: false,
            default: false,
        },
        id: {
            type: String,
            required: false,
            default: '',
        },
        maxlength: {
            type: Number,
            required: false,
            default: 255,
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        pattern: {
            type: String,
            required: false,
            default: null,
        },
        autocomplete: {
            type: String,
            required: false,
            default: 'off',
        },
        withPlaceholder: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    methods: {

        /**
         * On update field.
         */
        updateValue(value, type = 'input'){
            this.$emit(type, value);
        }
    },

    computed: {

        /**
         * Generate a unique id for inputs
         */
        getFieldId(){
            return (this.id == '') ? 'app-input-' + this._uid : this.id;
        },

        printPlaceholder() {
            if (this.withPlaceholder) {
                return this.placeholder;
            }
            return '';
        },
    }
}